/* eslint-disable react/jsx-props-no-spreading */
import { useIsVisible } from '@folklore/hooks';
import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';

import useCollection from '../../hooks/useCollection';
import useScrollEnter from '../../hooks/useScrollEnter';
import { useDocumentPageViewTracking } from '../../hooks/useTracking';

import { CollectionAdsTargetingProvider } from '../../contexts/AdsTargeting';
import * as CollectionComponents from '../collections/index';
import NotFoundPage from './NotFoundPage';

import styles from '../../styles/pages/collection-page.module.css';

interface CollectionPageProps {
    slug: string;
    current?: boolean;
    className?: string;
    contentClassName?: string;
    onEnter?: () => void;
    onLeave?: () => void;
}

function CollectionPage({
    slug,
    current = false,
    className = null,
    contentClassName = null,
    onEnter = null,
    onLeave = null,
}: CollectionPageProps) {
    const { collection = null, notFound = false } = useCollection(slug);
    const { type = null } = collection || {};
    const { ref: endRef, visible: endVisible = false } = useIsVisible({
        disabled: !current,
        // rootMargin: `100px 0px`,
    });

    useScrollEnter({
        leave: endVisible,
        disabled: !current,
        onEnter,
        onLeave,
    });

    useDocumentPageViewTracking(current && collection !== null, collection);

    const Collection = getComponentFromName(
        CollectionComponents,
        type,
        CollectionComponents.Default,
    );

    if (notFound) {
        return <NotFoundPage current={current} />;
    }

    return (
        <CollectionAdsTargetingProvider collection={collection}>
            <Collection
                {...collection}
                className={classNames([styles.container, className, contentClassName])}
            />
            <div
                ref={endRef}
                style={{
                    height: 1,
                }}
            />
        </CollectionAdsTargetingProvider>
    );
}

export default CollectionPage;
